import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import LearnNavigation from '../NavigationDropdown/LearnNavigation';
import Search from '../Search';

const MenuBar = props => {
  const {
    location,
    location: { pathname },
    isAuthenticated,
    menuItems
  } = props;

  const pathnameArray = pathname.split('/');

  const isDischarge = pathnameArray.includes('discharge');

  const showLearnNav = pathnameArray.includes('learn') || isDischarge;

  const showMenuItems =
    !showLearnNav &&
    !pathnameArray.includes('dashboard') &&
    !pathnameArray.includes('diary') &&
    !pathnameArray.includes('questions') &&
    !pathnameArray.includes('options');

  return (
    <nav
      className={classNames('header__secondary-nav', {
        'learn-navigation': showLearnNav
      })}
    >
      <Fragment>
        {showMenuItems && (
          <div className="header__secondary-item">
            <div className="header__secondary-item header__secondary-item--link">
              {menuItems &&
                menuItems.map(value => (
                    <NavLink
                      key={value.url}
                      className="full-width-link"
                      to={value.url}
                    >
                      <span className="full-width-link__text">{value.title}</span>
                    </NavLink>
                ))}
              {isAuthenticated && (
                <Fragment>
                  <NavLink className="full-width-link" to="/glossary">
                    <span className="full-width-link__text">Glossary</span>
                  </NavLink>
                </Fragment>
              )}
            </div>
          </div>
        )}
        {showLearnNav && (
          <LearnNavigation location={location} isDischarge={isDischarge} />
        )}
        {isAuthenticated && (
          <div className="header__secondary-item header__search-container header__search-container--desktop">
            <Search />
          </div>
        )}
      </Fragment>
    </nav>
  );
};

MenuBar.propTypes = {
  location: PropTypes.shape({ pathname: PropTypes.string }).isRequired,
  isAuthenticated: PropTypes.bool,
  menuItems: PropTypes.arrayOf(PropTypes.shape({}))
};

MenuBar.defaultProps = {
  isAuthenticated: false,
  menuItems: []
};

export default MenuBar;



// WEBPACK FOOTER //
// ./src/components/Header/MenuBar.js